export default "__VITE_ASSET__VEpDU5_I__"